import fetch from 'isomorphic-unfetch';

import { apiHeaders } from '../generic';

export default class WhatsappSubscribeApis {
  static subscription = async (event, user_id) => {
    const url = `${process.env.AUTH_SERVICE}api/v1/users/${user_id}/whatsapp/${event}`;
    const headers = apiHeaders();

    return fetch(url, {
      method: 'PATCH',
      headers,
      body: JSON.stringify({})
    });
  };
}
